import React from 'react';
import PropTypes from 'prop-types';

import Styles from './SideInput.module.scss';

const SideInput = ({
  label,
  valueRef,
  setValueRef,
  type = 'text',
  stateKey,
  required = false,
  ...props
}) => (
  <div className={Styles.SideInput}>
    <div>{label}</div>
    <input
      required={required}
      type={type}
      onChange={({ target: { value } }) =>
        stateKey
          ? setValueRef(state => ({ ...state, [stateKey]: value }))
          : setValueRef(value)
      }
      value={valueRef}
      {...props}
    />
  </div>
);

SideInput.defaultProps = {
  stateKey: null,
  type: 'text',
  required: undefined,
};

SideInput.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
  valueRef: PropTypes.string.isRequired,
  setValueRef: PropTypes.func.isRequired,
  stateKey: PropTypes.string,
  required: PropTypes.bool,
};

export default SideInput;
